import { useIsAuthenticated } from '@azure/msal-react';
import { REPORT_IT_WEBSITE_LINK } from '@constants';
import { SignOutIcon } from '@phosphor-icons/react';
export const SignOutLink = () => {
  const isAuthenticated = useIsAuthenticated();

  if (!isAuthenticated) return null;

  const handleLogout = async () => {
    sessionStorage.clear();
    localStorage.clear();
    window.location.href = REPORT_IT_WEBSITE_LINK;
  };

  return (
    <button
      onClick={handleLogout}
      className="text-action-link hover:text-action-link-hover md:text-action-button md:hover:bg-action-button-hover text-body md:focus:bg-action-focus md:focus:text-action-button flex w-full cursor-pointer items-center justify-start gap-1.5 border-none bg-transparent py-5 font-bold tracking-normal focus:underline focus:outline-none md:m-0 md:whitespace-nowrap md:rounded md:px-2.5 md:py-1 md:underline md:hover:text-white md:hover:no-underline"
    >
      Sign out
      <SignOutIcon size={18} className="md:hidden" />
    </button>
  );
};
